import * as React from 'react';
import { BuildersInfo } from '../../components/BuildersInfo';
import { getBuilders, getSellers, getNewbuildingDisplayName, getIsLeadFactory } from '../../selectors/newbuilding';
import { trackShowPhone } from '../../actions/analytics';
import { useSelector } from 'react-redux';
import { getGaLabel } from '../../selectors/analytics';

export const BuildersInfoContainer = () => {
  const gaLabel = useSelector(getGaLabel);

  const onOpenContactsCall = React.useCallback(() => {
    trackShowPhone(gaLabel, 'Open_jk_card_blockDeveloper');
  }, [gaLabel]);

  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const isLeadFactory = useSelector(getIsLeadFactory);
  const newbuildingDisplayName = useSelector(getNewbuildingDisplayName);

  return (
    <BuildersInfo
      builders={builders}
      sellers={sellers}
      newbuildingDisplayName={newbuildingDisplayName}
      isLeadFactory={isLeadFactory}
      trackActionOpenContactsCall={onOpenContactsCall}
    />
  );
};
